import { PText } from "@porsche-design-system/components-react"
import type { HeaderStatusMessageView } from "@slfinrtl/ui-bff-routes"
import { VehicleStatus } from "@slfinrtl/ui-bff-routes"
import { useMemo } from "react"
import { Link } from "react-router"
import { useDealerAppRoutes } from "#src/common/routes/useDealerAppRoutes"

interface StatusMessageProps {
	inventoryId: string
	view: HeaderStatusMessageView
}

export const StatusMessage = ({ inventoryId, view }: StatusMessageProps) => {
	const routes = useDealerAppRoutes()
	const route = useMemo(
		() =>
			view.vehicleStatus === VehicleStatus.RESERVED
				? routes?.inventoryList?.vehicleDetails?.reserve?.url(inventoryId)
				: routes?.inventoryList?.vehicleDetails?.sell?.url?.(inventoryId),
		[view.vehicleStatus, routes, inventoryId],
	)
	switch (view.vehicleStatus) {
		case undefined:
		case VehicleStatus.DELIVERED:
			return <PText size="xs">{view.message}</PText>

		case VehicleStatus.ONLINE_ORDERED:
		case VehicleStatus.ONLINE_RESERVED:
			return (
				<a href={view.link?.href} target="_blank" rel="noreferrer">
					<PText size="xs" color="inherit">
						{view.message}
					</PText>
				</a>
			)

		case VehicleStatus.SOLD:
			return (
				<PText size="xs" color="inherit">
					{view.message}
				</PText>
			)

		default:
			return route ? (
				<Link to={route}>
					<PText size="xs" color="inherit">
						{view.message}
					</PText>
				</Link>
			) : null
	}
}
